import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getTickets } from '../../../../redux/actions/TicketActions';
import { setSelectedProduct } from '../../../../redux/actions/ProductActions';
import { market } from '../../../../constants';
import ProductContainerDesktop from './desktop/ProductContainerDesktop';
import ProductContainerMobile from './mobile/ProductContainerMobile';
import { useProductListStyles } from './styles';
import { APP_SETTINGS } from '../../../../settings/AppSettings';

const { CHILE } = APP_SETTINGS.COUNTRIES;

const ProductList = ({ ...props }) => {
  const { mobile, products } = props;
  const classes = useProductListStyles({ window });
  const dispatch = useDispatch();

  const { tickets, ticketStatus } = useSelector((state) => state.ticketReducer);

  useEffect(() => {
    if (market === CHILE.SHORT_NAME && ticketStatus === 'idle')
      dispatch(getTickets());
    dispatch(setSelectedProduct({}));
  }, []);

  return (
    <Box
      display="grid"
      gridRowGap={mobile ? 0 : 24}
      className={classes.container}
    >
      {products.map((product, index) => (
        <React.Fragment key={index}>
          {!mobile && (
            <ProductContainerDesktop
              product={product}
              index={index}
              tickets={tickets}
            />
          )}
          {mobile && (
            <ProductContainerMobile product={product} tickets={tickets} />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

ProductList.propTypes = {
  mobile: PropTypes.bool,
  products: PropTypes.array,
  index: PropTypes.number,
  data: PropTypes.object,
};

export default ProductList;
